import { useRef, useState } from 'react';

import { ClickableProps, OnClickEvent } from './clickable.types';

const useClickableService = ({ onLongPress, onClick }: ClickableProps) => {
  const [action, setAction] = useState<'click' | 'longpress'>();

  const timerRef = useRef<NodeJS.Timeout>();
  const isLongPress = useRef<boolean>();

  const startPressTimer = () => {
    if (!onLongPress) return;

    isLongPress.current = false;
    timerRef.current = setTimeout(() => {
      isLongPress.current = true;
      setAction('longpress');
      onLongPress();
    }, 500);
  };

  const handleOnClick = (e: OnClickEvent) => {
    if (isLongPress.current) return;
    setAction('click');
    onClick(e);
  };

  const handleOnMouseUp = () => {
    clearTimeout(timerRef.current);
  };

  const handleOnTouchEnd = () => {
    if (action === 'longpress') return;
    clearTimeout(timerRef.current);
  };

  return {
    handlers: {
      onClick: handleOnClick,
      onMouseDown: startPressTimer,
      onMouseUp: handleOnMouseUp,
      onTouchStart: startPressTimer,
      onTouchEnd: handleOnTouchEnd,
    },
  };
};

export default useClickableService;
